import { AfterViewInit, Component } from '@angular/core';

import { ParentEvents } from '../utils/parent-events.service';

@Component({
    template: ``,
})
export abstract class BasePage implements AfterViewInit {
    protected constructor(protected parentEvents: ParentEvents) {}

    ngAfterViewInit() {
        this.parentEvents.scrollUp();
        this.parentEvents.resize();
    }
}
